import React from "react";
import { buildText } from "../Common/build.js";

const Footer = () => {
  return (
    <div id="bottom" className="footer">
      {buildText}
    </div>
  );
};

export default Footer;
